import React                from 'react';
import MainContentFooterPaging   from '../main-navigation/MainContentFooterPaging';
import scheduleModel             from './ScheduleModel';

const ScheduleFooter = React.memo(() => {
  return (
    <MainContentFooterPaging model={scheduleModel.pagingModel} />
  );
});

export default ScheduleFooter;